import Select from '@enerex/unified-ui-react/form/Select';

const getDefaultOptionLabel = (option: any) => {
    if (option === null || option === undefined) {
        return '';
    }

    if (typeof option !== 'object') {
        return String(option);
    }

    return String(
        option.label ??
            option.name ??
            option.title ??
            option.value ??
            option.id ??
            ''
    );
};

const getDefaultOptionValue = (option: any) => {
    if (option === null || option === undefined) {
        return '';
    }

    if (typeof option !== 'object') {
        return String(option);
    }

    return String(
        option.value ??
            option.id ??
            option.name ??
            option.label ??
            option.title ??
            ''
    );
};

const UnifiedSelect = ({
    getOptionLabel = getDefaultOptionLabel,
    getOptionValue = getDefaultOptionValue,
    className,
    ...props
}: any) => (
    <Select
        className={["unified-form-select", className].filter(Boolean).join(" ")}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        {...props}
    />
);

export default UnifiedSelect;
